import { createAsyncThunk } from '@reduxjs/toolkit';
import accountApi from '~/apis/account';
import {
  CREATE_ACCOUNT,
  UPDATE_ACCOUNT,
  GET_ACCOUNT,
  GET_ACCOUNTS,
  GET_SELECT_ACCOUNTS,
  GET_ACCOUNTS_SELECTION,
  GET_SELECT_SALEPERSONS,
} from '~/utils/constants/actionType';
import {
  IParamsGetAccounts,
  IResponseGetSelectAccounts,
  IResponseGetAccounts,
  IResponseGetAccount,
  IParamsAccountSelection,
  IParamsGetSelectAccounts,
} from '~/utils/interface/account';
import { IResponseAccount, IAccount } from '~/utils/interface/account';

export const handleGetSelectAccounts = createAsyncThunk<IResponseGetSelectAccounts, IParamsGetSelectAccounts>(
  GET_SELECT_ACCOUNTS,
  async (params: IParamsGetSelectAccounts, { rejectWithValue }) => {
    try {
      const res = await accountApi.getSelectAccounts(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetSelectSalePersons = createAsyncThunk<IResponseGetSelectAccounts, IParamsGetSelectAccounts>(
  GET_SELECT_SALEPERSONS,
  async (params: IParamsGetSelectAccounts, { rejectWithValue }) => {
    try {
      const res = await accountApi.getSelectAccounts(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateAccount = createAsyncThunk<IResponseAccount, IAccount>(
  CREATE_ACCOUNT,
  async (data: IAccount, { rejectWithValue }) => {
    try {
      const res = await accountApi.createAccount(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetAccounts = createAsyncThunk<IResponseGetAccounts, IParamsGetAccounts>(
  GET_ACCOUNTS,
  async (params: IParamsGetAccounts = {}, { rejectWithValue }) => {
    try {
      const res = await accountApi.getAccounts(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetAccount = createAsyncThunk<IResponseGetAccount, string>(
  GET_ACCOUNT,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await accountApi.getAccount(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleEditAccount = createAsyncThunk<IResponseAccount, { id: string | undefined; params: IAccount }>(
  UPDATE_ACCOUNT,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await accountApi.updateAccount(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetAccountsSelection = createAsyncThunk<IResponseGetSelectAccounts, IParamsAccountSelection>(
  GET_ACCOUNTS_SELECTION,
  async (params: IParamsAccountSelection, { rejectWithValue }) => {
    try {
      const res = await accountApi.getAccountsSelection(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
